import React from 'react'

const SvgUserSearch = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M9.166 11.12A5.003 5.003 0 017 7a5 5 0 119.842 1.247 7.008 7.008 0 00-2.014-.245 3 3 0 10-4.304 1.61c-.522.433-.98.941-1.358 1.507zM8.063 14h-.059C4.001 14 2 16 2 20c0 1.333.667 2 2 2h10.992a6.977 6.977 0 01-4.899-2H4c0-2.667 1.333-4 4-4h.063a7.06 7.06 0 010-2z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.992 10a5 5 0 014.178 7.747l.096.096 2.482 2.492c.393.447.243 1.013-.087 1.342-.33.328-.896.469-1.316.054l-.043-.043-2.533-2.53A5 5 0 1114.992 10zm-3 5a3 3 0 116 0 3 3 0 01-6 0z'
    />
  </svg>
)

export default SvgUserSearch
